import { FormControlLabel, styled, Switch, SwitchProps } from "@mui/material";
import { margin } from "@mui/system";


const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    margin: 8,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      marginLeft: 1,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#7963ff",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    }
  }));

const CustomFormControlLabel = styled(FormControlLabel)({
  marginLeft: 0,
});

export default function ISwitch(props: any) {

  const {label, onChange, checked, name, className, labelPlacement = "end"} = props;

  return (
    <>
      <CustomFormControlLabel
        checked={checked}
        name={name}
        className={className}
        control={
          <IOSSwitch
            onChange={onChange}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
      />
    </>
    );
}
